<template>
    <div style="width: 100%; height: 100%; position: relative">
        <div v-if="onLoad" style="width: 100%; height: 100%">
            <!-- 2023-11-28 pby 영상 로딩 화면 기능 추가 -->
            <video ref="video" poster="@/assets/images/Loading-Dots_green.gif" class="" id="video_player" :onloadeddata="onloadeddata" controls disablePictureInPicture playsinline controlsList="nodownload" style="width: 100%; height: 100%">
                <source :src="props.videoSrc + '#t=' + studyStore.videoPlayTime" />
                <!-- 2023-11-15 pby 동영상 제어용 수정-->
            </video>
        </div>
        <div :hidden="!isStop" style="position: absolute; top: 0px; width: 100%; height: 100%; background-color: #0000006b">
            <div :hidden="true" ref="playDiv" style="position: absolute; top: 45%; left: 50%; margin-left: -48px; margin-top: -48px">
                <div v-if="!isEnd" :class="[isSat ? 'satvideobutton' : 'videobutton']" @click="onplay">
                    <img src="@/assets/images/icon/icon_videoplay.svg" style="width: 36px; position: absolute; left: 36%; top: 29%" />
                </div>
                <div v-if="isEnd" :class="[isSat ? 'satvideobutton' : 'videobutton']" @click="onplay">
                    <img src="@/assets/images/icon/ico_replay.svg" style="width: 44px; position: absolute; left: 28%; top: 28%" />
                </div>
                <!-- <q-btn round color="#6f7376" :icon="!isEnd ? 'play_arrow' : 'replay'" style="" size="32px" @click="onplay" /> -->
            </div>
            <!-- <div style="position: absolute;top: 80%;right: 10px;  ">
				<q-btn rounded dense color="primary"
					:style="'padding: 0 20px;' + (!isEnd ? 'background-color: #6f7376!important;' : '')" size="12px">{{
		isEnd ?
			'개념이해완료'
			:
			'선생님의 영상강의를 통해 개념을 확인해 보세요.'
					}}</q-btn>
			</div> -->
        </div>
    </div>
    <!-- <q-btn round color="#6f7376" size="32px" @click="onPip" label="pip" /> -->
</template>

<script setup>
//2023-11-15 pby 동영상 제어용 추가 - onBeforeMount
import { ref, reactive, onMounted, onBeforeMount, onBeforeUnmount, watch, defineEmits, defineProps } from 'vue';
//2023-11-15 pby 동영상 제어용 추가
import { StudyStore } from '@/store/modules/study';
import { GlobalStore } from '@/store';
import { getUserRedis, setUserRedis } from '@/api/modules/login';
import { JSONParser } from '@amcharts/amcharts5';

let xxStartMilSec;
let xxPauseMilSec;

//2023-11-15 pby 동영상 제어용 추가
const studyStore = StudyStore();
const globalStore = GlobalStore();

const fixRunningTime = () => {
    if (xxPauseMilSec) {
        const diff = xxPauseMilSec - xxStartMilSec;
        xxStartMilSec = xxStartMilSec + diff;
    }
};

const isStop = ref(null);
const isEnd = ref(null);
const onLoad = ref(false);
const isSat = ref(false);
// let video;
const video = ref(null);

//2023-11-21 pby 영상 play 로딩 텀을 위한 추가
const playDiv = ref(null);

const emit = defineEmits(['setVideoStatus', 'onPlaying']);
const props = defineProps({
    videoSrc: {
        default: '',
    },
    videoTime: {
        default: 10,
    },
    isDone: {
        default: false,
    },
});

const onplay = () => {
    // console.log('--onplay--');
    xxStartMilSec = new Date().getTime();
    if (isStop.value) play1();
    else pause1();
    isStop.value = !isStop.value;
};
const play1 = () => {
    const playPromise = video.value?.play();
    if (playPromise !== undefined) {
        playPromise
            .then(() => {
                emit('onPlaying', true);
                fixRunningTime();
            })
            .catch(() => {});
    }
};
const pause1 = () => {
    // console.log('--pause1--');
    video.value?.pause();
    emit('onPlaying', false);
    xxPauseMilSec = new Date().getTime();
    if (id != '' && id != null) {
        //2023-11-20 pby 사용자 정보가 존재 시 적용.
        if (video.value) {
            if (!video.value.ended) {
                //2023-11-24 pby 영상제어 통일
                saveVideoTime();
            }
        }
    }
};
const onPip = () => {
    video.value.requestPictureInPicture();
};

const onloadeddata = (p) => {
    var supposedCurrentTime = p.videoTime;

    // const video = ref(null)
    // video = document.getElementById('video_player');
    isStop.value = true;
    isEnd.value = false;
    // console.log(video);
    // video.value.currentTime = 6;
    const superPass = localStorage.getItem('videoSuperPass');
    const timeupdate = () => {
        // console.log('-timeupdate--video.value.seeking--',video.value.seeking)
        if (!superPass) {
          if (video.value && !video.value.seeking) {
            supposedCurrentTime = supposedCurrentTime > video.value.currentTime ? supposedCurrentTime : video.value.currentTime;
          }
        }
    };
    const seeking = () => {
        // var delta = video.value.currentTime - supposedCurrentTime;
        // if (Math.abs(delta) > 0.01) {
        // 	console.log("Seeking is disabled");
        // 	video.value.currentTime = supposedCurrentTime;
        // }
        if (!superPass) {
          if (!props.isDone) {
            if (video.value.currentTime > supposedCurrentTime) {
              video.value.currentTime = supposedCurrentTime;
            }
          }
        }
    };
    const ended = () => {
        // 동영상 시청종료시 프로세스
        isEnd.value = true;
        isStop.value = true;
        emit('setVideoStatus', xxStartMilSec);
        //2023-11-24 pby 영상제어 통일
        saveVideoTime();
    };
    if (video.value) {
        video.value.removeEventListener('timeupdate', timeupdate);
        video.value.removeEventListener('seeking', seeking);
        video.value.removeEventListener('ended', ended);
        video.value.removeEventListener('play', play1);
        video.value.removeEventListener('pause', pause1);
        video.value.addEventListener('timeupdate', timeupdate);
        video.value.addEventListener('seeking', seeking);
        video.value.addEventListener('ended', ended);
        video.value.addEventListener('play', play1);
        video.value.addEventListener('pause', pause1);
    }
};

const key = globalStore.userInfo.studentSeq + '_' + studyStore.process.exam.learningHistorySeq + ':' + props.videoSrc.substring(props.videoSrc.lastIndexOf('/') + 1, props.videoSrc.lastIndexOf('.mp4'));
const id = globalStore.userInfo.loginId;
//2023-11-15 pby 동영상 제어용 추가
onBeforeMount(() => {
    if (id != '' && id != null) {
        //2023-11-16 pby 사용자 정보가 존재 시 적용.
        getUserRedis(key, (rs) => {
            if (rs == null || rs == undefined) {
                //2023-11-15 pby 처음 동영상 재생 시 null 데이터 처리
                studyStore.setVideoPlayTime('0.001');
                studyStore.setVideoStatus('I');
                video.value.currentTime = '0.001';
            } else {
                //2023-11-24 pby 영상 상태 처리를 위한 데이터 json화
                const result = JSONParser.parse(rs);
                studyStore.setVideoPlayTime(result.videoTime);
                studyStore.setVideoStatus(result.videoStatus);
                video.value.currentTime = studyStore.videoPlayTime;
            }
        });
    }
});

onMounted(() => {
    onLoad.value = true;
    // setTimeout(() => {
    // 	onLoad.value = true;
    // 	init(props);
    // }, 100)
    isSat.value = window.location.pathname == '/sat' ? true : false;

    //2023-11-15 pby 동영상 제어용 추가
    window.addEventListener('beforeunload', saveVideoTime);
    //2023-11-21 pby 영상 play 로딩 텀을 위한 추가
    setTimeout(() => {
        if (playDiv.value) {
            playDiv.value.hidden = false;
        }
    }, 2000);
});

onBeforeUnmount(() => {
    saveVideoTime();
});

//2023-11-15 pby 동영상 제어용 추가
const saveVideoTime = () => {
    if (id != '' && id != null) {
        //2023-11-16 pby 사용자 정보가 존재 시 적용.
        //2023-11-24 pby 영상정보 상태값 추가를 위한 json화
        const videoData = {
            videoTime: null,
            videoStatus: null,
        };
        if (video.value) {
            if (video.value.ended) {
                //동영상 완료 시 초기화 로직 추가
                studyStore.setVideoPlayTime('0.001');
                studyStore.setVideoStatus('C');
                videoData.videoTime = studyStore.videoPlayTime;
                videoData.videoStatus = studyStore.videoStatus;
                setUserRedis(key, videoData, () => {});
            } else if (!video.value.ended) {
                studyStore.setVideoPlayTime(video.value.currentTime);
                if (studyStore.videoStatus === 'C') {
                    studyStore.setVideoStatus('C');
                } else {
                    studyStore.setVideoStatus('I');
                }
                videoData.videoTime = studyStore.videoPlayTime;
                videoData.videoStatus = studyStore.videoStatus;
                setUserRedis(key, videoData, () => {});
            }
        }
    }
};

watch(
    () => props,
    (newValue) => {
        onLoad.value = true;
        // setTimeout(() => {
        // 	onLoad.value = true;
        // 	init(props);
        // }, 100)
    },
);
</script>

<style lang="scss" scoped>
.videobutton {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background-color: #00000070;
    cursor: pointer;
}
.videobutton:hover {
    background-color: #00000090;
}

.satvideobutton {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background-color: #6f737670;
    cursor: pointer;
}

.satvideobutton:hover {
    background-color: #6f737690;
}
</style>
